import React from 'react'

function Students() {
    return (
        <div>
            <div className="basic-3">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="text-container">
                                <h2>Who Should Attend The Data Analytics & Machine learning Course</h2>
                                <p>This course is for anyone passionate about the web and especially fit for those seeking to improve their online presence for company websites and blogs </p>
                                
                            </div> 
                        </div> 
                        <div className="col-lg-6">
                            <img className="img-fluid" src="images/students.jpg" alt="alternative" />
                        </div> 
                    </div> 
                </div> 
            </div>



            
            
        </div>
    )
}

export default Students
